import { render, staticRenderFns } from "./gameStatus.vue?vue&type=template&id=4f8e553c"
import script from "./gameStatus.vue?vue&type=script&lang=js"
export * from "./gameStatus.vue?vue&type=script&lang=js"
import style0 from "./gameStatus.vue?vue&type=style&index=0&id=4f8e553c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports